import {
	IconAnalyticsOutline,
	IconChartColumnFilled,
	IconChatFilled,
	IconFavoriteFilled,
	IconStarFilled,
	IconViewFilled,
} from '@featuring-corp/icons';
import { useTranslation } from 'react-i18next';
import React from 'react';
import CardGroupSection, {
	CardGroupItem,
} from '@components/report/card-group-section/CardGroupSection';

export type PickedCardProps = Pick<CardGroupItem, 'content' | 'disabled'>;

export interface KeyMetricsIgProps {
	realFollowers?: PickedCardProps;
	averageReach?: PickedCardProps;
	averageViews?: PickedCardProps;
	averageLikes?: PickedCardProps;
	averageComments?: PickedCardProps;
	engagementRate?: PickedCardProps;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const KeyMetricsIg = ({
	isLoading,
	isError,
	lackOfPermission,
	...props
}: KeyMetricsIgProps) => {
	const status = { isLoading, isError, lackOfPermission };
	const { t } = useTranslation('infReportInstagram');

	const cardGroup: CardGroupItem[] = [
		{
			label: t('features.report.section-content.ig.key-metrics.real-follower.label'),
			tooltip: t('features.report.section-content.ig.key-metrics.real-follower.tooltip'),
			icon: IconStarFilled,
			...props.realFollowers,
		},
		{
			label: t('features.report.section-content.ig.key-metrics.avg-reach.label'),
			tooltip: t('features.report.section-content.ig.key-metrics.avg-reach.tooltip'),
			icon: IconAnalyticsOutline,
			...props.averageReach,
		},
		{
			label: t('features.report.section-content.ig.key-metrics.avg-video-view.label'),
			tooltip: t('features.report.section-content.ig.key-metrics.avg-video-view.tooltip'),
			icon: IconViewFilled,
			...props.averageViews,
		},
		{
			label: t('features.report.section-content.ig.key-metrics.avg-like.label'),
			tooltip: t('features.report.section-content.ig.key-metrics.avg-like.tooltip'),
			icon: IconFavoriteFilled,
			...props.averageLikes,
		},
		{
			label: t('features.report.section-content.ig.key-metrics.avg-comment.label'),
			tooltip: t('features.report.section-content.ig.key-metrics.avg-comment.tooltip'),
			icon: IconChatFilled,
			...props.averageComments,
		},
		{
			label: t('features.report.section-content.ig.key-metrics.real-engagement.label'),
			tooltip: t(
				'features.report.section-content.ig.key-metrics.real-engagement.tooltip',
			),
			icon: IconChartColumnFilled,
			...props.engagementRate,
		},
	];

	return <CardGroupSection cardGroup={cardGroup} {...status} />;
};

export default KeyMetricsIg;
